/* ==========================================================================
   Hesaplayıcılar — saf JS, bağımlılık yok.
   Formüller DATA.md bölüm 4'ten.

   İki farklı yerleşimde çalışır:
   1) Ana sayfa kartı — sonuç, hesaplayıcının kendi içindeki [data-km-*-result]
   2) Rehber turuncu paneli — sonuç, yandaki beyaz kartta [data-km-calc-mirror]
   ========================================================================== */
(function () {
  'use strict';

  // DATA.md bölüm 4: önerilen aralık = boy + lo … boy + hi
  var SKI_LEVELS = {
    baslangic: {
      lo: -16,
      hi: -10,
      note: 'Kısa kayak daha kolay döner, hata affeder. İlk sezonda bu aralık doğru.',
    },
    orta: {
      lo: -10,
      hi: -4,
      note: 'Dengeli aralık. Pistte hem kısa dönüş hem hız istiyorsan orta değeri seç.',
    },
    ileri: {
      lo: -5,
      hi: 2,
      note: 'Uzun kayak yüksek hızda stabil. Kısa yarıçaplı dönüşten çok hız arıyorsan üst değeri seç.',
    },
  };

  /**
   * Sonucun yazılacağı elemanları bulur.
   * Turuncu panel içindeysek yandaki sonuç kartını, değilsek hesaplayıcının
   * kendi içindeki alanı kullanır.
   */
  function outputs(root, type) {
    var panel = root.closest ? root.closest('.km-calcpanel') : null;

    if (panel) {
      return {
        value: panel.querySelector('[data-km-calc-mirror]'),
        note: panel.querySelector('[data-km-calc-mirror-note]'),
      };
    }

    return {
      value: root.querySelector('[data-km-' + type + '-result]'),
      note: root.querySelector('[data-km-' + type + '-note]'),
    };
  }

  function write(out, value, note) {
    if (out.value) out.value.textContent = value;
    if (out.note) out.note.textContent = note || '';
  }

  /* ---------------------------------------------------------- kayak boyu */

  /**
   * "Listele" butonunu seçili seviyeye göre filtrelenmiş koleksiyona bağlar.
   * Filtre değeri butonun kendi data-km-skicalc-filter'ından gelir — bu değer
   * ürünlerdeki custom.level_label metaalanının birebir karşılığı.
   */
  function linkCta(cta, activeLevelBtn) {
    if (!cta || !activeLevelBtn) return;

    var base = cta.getAttribute('data-km-skicalc-cta-base');
    var key = cta.getAttribute('data-km-skicalc-cta-key');
    var value = activeLevelBtn.getAttribute('data-km-skicalc-filter');

    if (!base || !key || !value) return;

    cta.href = base + (base.indexOf('?') === -1 ? '?' : '&') + key + '=' + encodeURIComponent(value);
  }

  function initSkiCalculator(root) {
    var range = root.querySelector('[data-km-skicalc-range]');
    var heightOut = root.querySelector('[data-km-skicalc-height]');
    var levels = root.querySelectorAll('[data-km-skicalc-level]');
    var cta = root.querySelector('[data-km-skicalc-cta]');
    var out = outputs(root, 'skicalc');
    var level = 'orta';
    var activeLevelBtn = root.querySelector('[data-km-skicalc-level].is-active');

    if (!range || !out.value) return;

    function update() {
      var h = Number(range.value);
      if (heightOut) heightOut.textContent = h;

      var cfg = SKI_LEVELS[level];
      write(out, h + cfg.lo + '–' + (h + cfg.hi) + ' cm', cfg.note);
      linkCta(cta, activeLevelBtn);
    }

    range.addEventListener('input', update);

    levels.forEach(function (btn) {
      btn.addEventListener('click', function () {
        level = btn.getAttribute('data-km-skicalc-level');
        activeLevelBtn = btn;
        levels.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', String(on));
        });
        update();
      });
    });

    update();
  }

  /* ---------------------------------------------------------- baton boyu */

  function initPoleCalculator(root) {
    var range = root.querySelector('[data-km-pole-range]');
    var heightOut = root.querySelector('[data-km-pole-height]');
    var out = outputs(root, 'pole');
    if (!range || !out.value) return;

    function update() {
      var h = Number(range.value);
      if (heightOut) heightOut.textContent = h;
      // DATA.md: boy × 0,68, 5 cm'e yuvarlanır
      write(out, Math.round((h * 0.68) / 5) * 5 + ' cm', 'Batonu ters tutup rozetin altından kavradığında dirseğin 90 derece olmalı.');
    }

    range.addEventListener('input', update);
    update();
  }

  /* ------------------------------------------------------ snowboard boyu */

  // DATA.md bölüm 4 — kiloya göre tablo
  var BOARD_TABLE = [
    { max: 50, out: '128–136 cm' },
    { max: 60, out: '138–144 cm' },
    { max: 70, out: '144–150 cm' },
    { max: 80, out: '150–156 cm' },
    { max: 90, out: '156–162 cm' },
    { max: Infinity, out: '159–165 cm' },
  ];

  function initBoardCalculator(root) {
    var range = root.querySelector('[data-km-board-range]');
    var weightOut = root.querySelector('[data-km-board-weight]');
    var out = outputs(root, 'board');
    if (!range || !out.value) return;

    function update() {
      var w = Number(range.value);
      if (weightOut) weightOut.textContent = w;

      for (var i = 0; i < BOARD_TABLE.length; i++) {
        if (w <= BOARD_TABLE[i].max) {
          write(out, BOARD_TABLE[i].out, 'Ayakkabı numaran 45 ve üzeriyse wide board öneriyoruz.');
          return;
        }
      }
    }

    range.addEventListener('input', update);
    update();
  }

  /* --------------------------------------------------------- kask ölçüsü */

  // DATA.md bölüm 4 — baş çevresi (cm) → beden
  var HELMET_TABLE = [
    { max: 54, out: 'XS/S' },
    { max: 57, out: 'S/M' },
    { max: 60, out: 'M/L' },
    { max: Infinity, out: 'L/XL' },
  ];

  function initHelmetCalculator(root) {
    var range = root.querySelector('[data-km-helmet-range]');
    var circOut = root.querySelector('[data-km-helmet-circumference]');
    var out = outputs(root, 'helmet');
    if (!range || !out.value) return;

    function update() {
      var c = Number(range.value);
      if (circOut) circOut.textContent = c;

      for (var i = 0; i < HELMET_TABLE.length; i++) {
        if (c <= HELMET_TABLE[i].max) {
          write(out, HELMET_TABLE[i].out, 'Kaskı bereyle kullanacaksan ölçüyü bereyle al.');
          return;
        }
      }
    }

    range.addEventListener('input', update);
    update();
  }

  function init() {
    document.querySelectorAll('[data-km-skicalc]').forEach(initSkiCalculator);
    document.querySelectorAll('[data-km-polecalc]').forEach(initPoleCalculator);
    document.querySelectorAll('[data-km-boardcalc]').forEach(initBoardCalculator);
    document.querySelectorAll('[data-km-helmetcalc]').forEach(initHelmetCalculator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
